(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[196],{

/***/ 5106:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/[slug]",
      function () {
        return __webpack_require__(955);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1198:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);


function BlogListCard(param) {
    let { data  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        className: "block",
        href: "/blogs/".concat(data.slug),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: data.title_image,
                alt: data.title,
                className: "h-[200px] object-cover w-full"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                className: "text-[22px] md:text-[18px] mt-[20px] text-center leading-[120%]",
                children: [
                    " ",
                    data.title,
                    "  "
                ]
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (BlogListCard);


/***/ }),

/***/ 1370:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


function InfiniteLoader(param) {
    let { show , message , actionOnShow , extras ={}  } = param;
    const intersectionOptions = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        return {
            root: null,
            rootMargin: "0px",
            threshold: 0
        };
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const loader = document.getElementById("inifinte-loader");
        const observer = new IntersectionObserver(intersectionCallback, intersectionOptions);
        if (loader) observer.observe(loader);
        return ()=>{
            if (loader) observer.unobserve(loader);
        };
    }, [
        extras
    ]);
    const intersectionCallback = (entries)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                actionOnShow();
            }
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: show && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("small", {
            id: "inifinte-loader",
            className: "text-theme-orange",
            children: [
                " ",
                message,
                " "
            ]
        })
    });
}
InfiniteLoader.defaultProps = {
    show: false,
    message: "loading more..."
};
/* harmony default export */ __webpack_exports__["Z"] = (InfiniteLoader);


/***/ }),

/***/ 2868:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);


function Title(param) {
    let { title  } = param;
    const Title = "".concat(title, " | APIdrug Platform");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
            children: Title
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Title);


/***/ }),

/***/ 955:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _components_title__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2868);
/* harmony import */ var _components_Blog_ListCard__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1198);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9473);
/* harmony import */ var _store_CoreSlice__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1266);
/* harmony import */ var _components_General_InfiniteLoader__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1370);
/* harmony import */ var _MixPanel__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5067);








function BlogDetail(param) {
    let { data , param: param1  } = param;
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useDispatch */ .I0)();
    const { blogList  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)((state)=>state.core);
    const currentPage = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(1);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(()=>{
        const params = {
            page: 1,
            page_size: 30,
            exclude: param1
        };
        dispatch((0,_store_CoreSlice__WEBPACK_IMPORTED_MODULE_5__/* .getBlogList */ .De)(params));
        _MixPanel__WEBPACK_IMPORTED_MODULE_7__/* .MixpanelTracking.getInstance */ .n.getInstance().pageViewed({});
    }, []);
    // FUNCTIONS
    const getUserName = (blog)=>{
        if (blog.created_by_user_instance_details) return blog.created_by_user_instance_details.name;
        else if (blog.created_by) return blog.created_by;
        return "Anonymous User";
    };
    const loadMoreBlogs = ()=>{
        currentPage.current = currentPage.current + 1;
        if (blogList.data.next) {
            dispatch((0,_store_CoreSlice__WEBPACK_IMPORTED_MODULE_5__/* .getBlogList */ .De)({
                page: currentPage.current,
                page_size: 30,
                type: "append"
            }));
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_title__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                title: data.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "py-10",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "px-[20px] md:px-0 md:w-[60%] lg:w-[43%] md:mx-auto",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h1", {
                                className: "text-[36px] leading-[43px] text-center font-semibold",
                                children: [
                                    " ",
                                    data.title,
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                className: "text-center font-light mt-[24px] mb-[32px]",
                                children: [
                                    " ",
                                    data.brief_description,
                                    " "
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-full",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            className: "w-full h-[600px] object-cover",
                            src: data.title_image,
                            alt: "Title Image"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "md:w-[50%] md:mx-auto lg:w-[40]",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "h-[3px] w-[90%] mx-auto bg-[#000000] my-[24px] mb-[30px]"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex px-[20px]",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        className: "rounded-[50%] mr-[16px] w-[50px]",
                                        src: "/Support/Profile.png",
                                        alt: "Profile"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "text-[15px]",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                children: [
                                                    " ",
                                                    getUserName(data),
                                                    " "
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("small", {
                                                className: "font-light",
                                                children: [
                                                    " ",
                                                    data.blog_created_on,
                                                    " "
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "px-[20px] py-[32px] unreset",
                                dangerouslySetInnerHTML: {
                                    "__html": data.content
                                }
                            })
                        ]
                    }),
                    blogList.list.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex items-center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "h-[3px] bg-[black] w-[50%]"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: "/TwoEyes.svg",
                                        alt: "",
                                        className: "w-[20%] md:w-[70px]"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "h-[3px] bg-[black] w-[50%]"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                className: "text-[32px] text-center font-semibold my-[30px]",
                                children: "What to read next"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: " px-[20px] md:grid md:grid-cols-2 lg:grid-cols-3 gap-x-[30px] gap-y-[50px] md:w-[80%] lg:w-[70%] md:mx-auto",
                                children: [
                                    blogList.list.map((blog)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "mb-[40px] md:mb-0 cursor-pointer",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Blog_ListCard__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                                data: blog
                                            })
                                        }, blog.id)),
                                    blogList.data.next && true && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "text-center mt-10",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_General_InfiniteLoader__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                            show: blogList.data.next && true,
                                            message: "Loading More...",
                                            actionOnShow: loadMoreBlogs,
                                            extras: blogList
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (BlogDetail);


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(3121)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(5106); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);